"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateDockerfileBaseImageNameErrorCode = exports.DockerFileAnalysisErrorCode = void 0;
var DockerFileAnalysisErrorCode;
(function (DockerFileAnalysisErrorCode) {
    DockerFileAnalysisErrorCode["BASE_IMAGE_NAME_NOT_FOUND"] = "BASE_IMAGE_NAME_NOT_FOUND";
    DockerFileAnalysisErrorCode["BASE_IMAGE_NON_RESOLVABLE"] = "BASE_IMAGE_NON_RESOLVABLE";
})(DockerFileAnalysisErrorCode || (exports.DockerFileAnalysisErrorCode = DockerFileAnalysisErrorCode = {}));
var UpdateDockerfileBaseImageNameErrorCode;
(function (UpdateDockerfileBaseImageNameErrorCode) {
    UpdateDockerfileBaseImageNameErrorCode["BASE_IMAGE_NAME_FRAGMENTED"] = "BASE_IMAGE_NAME_FRAGMENTED";
    UpdateDockerfileBaseImageNameErrorCode["BASE_IMAGE_NAME_NOT_FOUND"] = "BASE_IMAGE_NAME_NOT_FOUND";
    UpdateDockerfileBaseImageNameErrorCode["DOCKERFILE_GENERATION_FAILED"] = "DOCKERFILE_GENERATION_FAILED";
})(UpdateDockerfileBaseImageNameErrorCode || (exports.UpdateDockerfileBaseImageNameErrorCode = UpdateDockerfileBaseImageNameErrorCode = {}));
//# sourceMappingURL=types.js.map